var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1",
    cx: 13,
    cy: 12,
    rx: 13,
    ry: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 14.3465C16.2267 18.3738 19.4786 16.9616 19.1115 14.3465C18.7443 11.7314 13.9646 14.3465 10.6667 14.3465Z",
    stroke: "#628048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2369 11.4045C13.2369 11.4045 9.1981 6.1744 13.2369 6.50128C17.2757 6.82817 13.2369 11.4045 13.2369 11.4045Z",
    stroke: "#628048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6428 8.13568C22.0488 10.097 25.7204 11.0776 23.1502 8.13568C20.5801 5.19372 17.6428 8.13568 17.6428 8.13568Z",
    stroke: "#628048"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M4 20.1081L19 6.16211",
    stroke: "#628048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M6.99986 16.8649C6.99986 16.8649 9.66649 11.027 6.99986 12.3243C4.33324 13.6216 6.99986 16.8649 6.99986 16.8649Z",
    stroke: "#628048"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f8dad1add36e5cbb3696c976efea24d3.svg";
export { ForwardRef as ReactComponent };